import React from 'react';
import Translate from '@prisjakt/ui-translate';
import shallowEqual from 'shallowequal';
import SentimentBadge from '../sentiment-badge';

import { BadgesFragment } from '../../types';

import * as S from './styles';

type OwnProps = {
  badges: NonNullable<BadgesFragment['storeBadges']>;
};

const StoreBadgeList = React.memo(
  ({ badges }: OwnProps) => {
    if (!badges || !badges.length) {
      return null;
    }

    return (
      <div>
        <S.StoreBadgeListTitle>
          <Translate domain="product">store-badge.title</Translate>
        </S.StoreBadgeListTitle>
        {badges.map(badge =>
          badge ? (
            <SentimentBadge
              badge={badge}
              key={badge.id}
              showNrOfReviewsAs="text"
            />
          ) : null
        )}
      </div>
    );
  },
  ({ badges: prevBadges }, { badges: nextBadges }) => {
    if (!prevBadges && !nextBadges) {
      return true;
    }
    if (
      (!prevBadges && nextBadges) ||
      (prevBadges && !nextBadges) ||
      prevBadges.length !== nextBadges.length
    ) {
      return false;
    }
    return prevBadges.every((badge, i) => shallowEqual(badge, nextBadges[i]));
  }
);

export default StoreBadgeList;
